import { styled } from '@volkswagen-onehub/components-core';
import { AriaLabels } from './VehicleToggleButtonCarousel';

export const VehicleToggleButtonCarouselWrapper = styled.div(
  ({ theme }) => `
  [aria-label='${AriaLabels.NAVIGATION_ARIA_LABEL}'] {
    margin-top: ${theme.size.static300};
  }

  *:focus {
    box-shadow: none;
  }

  [aria-roledescription='slide'] > div {
    display: flex;
    height: 100%;
    width: 100%;
  }
`
);
